import { Pipe, PipeTransform } from '@angular/core'

import { config, getLocalizedRelativeTime } from '@flowx/core-sdk'

@Pipe({
  name: 'flxTimeElapsed',
  pure: true,
  standalone: true,
})
export class FlxTimeElapsedPipe implements PipeTransform {
  transform(value: any): any {
    return getLocalizedRelativeTime(value, config().language)
  }
}
